import type { MessageDeliveryStatus } from 'models';
import { useMemo } from 'react';
import type { IconProperties, TextProperties } from 'ui';

type ChatMessageFooterContent = {
  iconColor: NonNullable<IconProperties['color']>;
  iconName: IconProperties['icon'];
  label: string;
  textType?: TextProperties['type'];
};

type P = {
  deliveryStatus: MessageDeliveryStatus;
};

export const useChatMessageFooter = ({ deliveryStatus }: P) =>
  useMemo((): ChatMessageFooterContent | null => {
    switch (deliveryStatus) {
      case 'failed':
        return {
          iconColor: 'error',
          iconName: 'warning-line',
          label: 'Failed',
          textType: 'danger',
        };
      case 'saving':
        return {
          iconColor: 'text',
          iconName: 'time-line',
          label: 'Saving...',
        };
      case 'sending':
        return {
          iconColor: 'text',
          iconName: 'time-line',
          label: 'Sending...',
        };
      case 'sent':
        return null;
    }
  }, [deliveryStatus]);
